import { render, staticRenderFns } from "./exhibition-info-certApply.vue?vue&type=template&id=838e6650&scoped=true&"
import script from "./exhibition-info-certApply.vue?vue&type=script&lang=js&"
export * from "./exhibition-info-certApply.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-info-certApply.vue?vue&type=style&index=0&id=838e6650&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "838e6650",
  null
  
)

export default component.exports